import classes from "./AddCompany.module.css";
import Xicon from "../../../images/Xicon.svg";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createCompany } from "../../../redux/company/createCompany";
import {
  setIsAddCompanyModalShown,
  setIsEditMode,
} from "../../../redux/globalFnSlice";
import { useEscapeKeyClose } from "../../../helperFunctions/customHooks/useEscapeKeyClose";
import { useClickOutsideClose } from "../../../helperFunctions/customHooks/useClickOutsideClose";
import { LoadingSpinner } from "../../loadingSpinner/LoadingSpinner";
import { updateCompany } from "../../../redux/company/updateCompany";
import translations from "../../../en.json";
import useEnterKey from "../../../helperFunctions/customHooks/useEnterKeySubmit";

export function AddCompany() {
  const [name, setName] = useState("");
  const dispatch = useDispatch();
  const modalRef = useRef();

  // Redux state variables
  const createCompanyState = useSelector((state) => state.createCompany);
  const updateCompanyState = useSelector((state) => state.updateCompany);
  const { isEditMode, selectedData } = useSelector((state) => state.global);

  function toggleModal() {
    dispatch(setIsAddCompanyModalShown());
    dispatch(setIsEditMode(false));
  }

  // If isEditMode is true then populate the fields with the data from selectedData.
  useEffect(() => {
    if (isEditMode && selectedData) {
      setName(selectedData.c_name);
    }
  }, [isEditMode, selectedData]);

  // Function to handle form submission.
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditMode) {
      dispatch(updateCompany({ company_id: selectedData.c_id, c_name: name }));
    } else {
      dispatch(
        createCompany({
          c_name: name,
        })
      );
    }
  };

  // Function for submitting the form when presing the enter key on the keyboard.
  useEnterKey(handleSubmit);

  const modalText = translations.addCompanyModal;

  // Functions for closing the modal when pressing Escape button on keyboard or clicking outside the modal.
  useEscapeKeyClose(toggleModal);
  useClickOutsideClose(modalRef, toggleModal);

  const isStatusLoading =
    createCompanyState.status === "loading" ||
    updateCompanyState.status === "loading";
  const isBtnDisabled = isStatusLoading || name === "";

  const headerText = isEditMode
    ? modalText.headerTextEdit
    : modalText.headerTextAdd;

  return (
    <div className={classes.container} ref={modalRef}>
      <div className={classes.header}>
        <h3>{headerText}</h3>
        <span>
          <img
            src={Xicon}
            alt={modalText.closeModalIconAlt}
            onClick={toggleModal}
          />
        </span>
      </div>
      <form className={classes.addCompanyForm} onSubmit={handleSubmit}>
        <div className={classes.formElement}>
          <label htmlFor="c_name">{modalText.nameLabel}</label>
          <input
            type="text"
            id="c_name"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <button className={classes.saveBtn} disabled={isBtnDisabled}>
          {isStatusLoading ? <LoadingSpinner /> : modalText.saveBtn}
        </button>
      </form>
    </div>
  );
}
